import CustomerItemsCarousel from '@apps/components/carousel/CustomItemsCarousel';
import Link from 'next/link';
import React from 'react';
import { SectionHeader } from '@apps/components/section-header';

const RelatedPosts = ({ data, breakpoint }) => {
  const drawerItems = {
    render: (_, item) => {
      const { id, image, title, text, slug, date } = item;
      return (
        <>
          <article key={id} className={'col-span-1'}>
            <div
              className='border border-jacarta-100 dark:border-jacarta-600 h-full rounded-2xl overflow-hidden transition-shadow hover:shadow-lg'>
              <figure className='group overflow-hidden'>
                <Link href={`/blog/${slug}`}>
                  {/* eslint-disable-next-line @next/next/no-img-element */}
                  <img
                    src={image}
                    alt={title}
                    style={{ height: 250 }}
                    className='w-full object-cover transition-transform duration-[1600ms] will-change-transform group-hover:scale-105 '
                  />
                </Link>
              </figure>

              {/* <!-- Body --> */}
              <div style={{ height: 'calc(100% - 250px)' }}
                   className='dark:bg-[#09092C] rounded-b-[1.25rem] bg-white p-[10%]'>
                {/* <!-- Meta --> */}
                <h2
                  className='font-display text-jacarta-700 dark:hover:text-primary hover:text-accent mb-4 text-xl dark:text-white blog-list-text'>
                  <Link href={`/blog/${slug}`}>
                    {title}
                  </Link>
                </h2>
                <p className='dark:text-jacarta-200 mb-8 blog-list-text'>{text}</p>

                {/* <!-- Date / Time --> */}
                <div className='text-jacarta-400 flex flex-wrap items-center space-x-2 text-sm'>
                  <span>{date}</span>
                </div>
              </div>
            </div>
          </article>
        </>
      );
    }
  };

  return <CustomerItemsCarousel data={data} drawerItems={drawerItems} breakpoint={breakpoint} />;
};

export default RelatedPosts;
